import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { BrowserWindow, BrowserWindowSymbol, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import { getFullId } from '@wix/thunderbolt-commons'
import { ComponentDetectorConfig } from './types'

const viewerManagerComponentDetectorApiFactory = (
	browserWindow: NonNullable<BrowserWindow>,
	{ components }: ComponentDetectorConfig
): IViewerManagerImplementor<'componentDetector'> => {
	const getElementsUnderXY = (x: number, y: number) => browserWindow.document.elementsFromPoint(x, y)
	return {
		componentDetector: {
			getComponentsUnderXY: (x: number, y: number): Array<string> => {
				const elements = getElementsUnderXY(x, y)
				return elements.reduce((acc, e) => {
					if (e.id && components[getFullId(e.id)]) {
						acc.push(e.id)
					}
					return acc
				}, [] as Array<string>)
			},
			getElementsUnderXY,
		},
	}
}
export const ViewerManagerComponentDetectorApi = withDependencies(
	[BrowserWindowSymbol, named(EditorFeatureConfigSymbol, name)],
	viewerManagerComponentDetectorApiFactory
)
